<template>
    <footer class="tsi-footer">
        <div class="tsi-container tsi-footer__inner">
            <div>
                <div class="tsi-footer__org">上海韬视信息技术有限公司</div>
                <div>版权所有 © {{ year }} 上海韬视&#12288;沪ICP备16023729号</div>
                <div class="tsi-footer__muted">支持的浏览器：Chrome / Safari / Firefox / Edge，国内浏览器请使用极速模式。</div>
            </div>
            <div class="tsi-footer__right">
                <div>技术支持 TEL：021-54412956</div>
                <div>Email：<a href="mailto:service@tsied.com">service@tsied.com</a></div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "tsi-footer",
    computed: {
        year() {
            return new Date().getFullYear();
        },
    },
}
</script>
